export default __webpack_public_path__ + "static/media/Table.b85f712c.webp";